const CardStatus = {
    ACTIVE: 0,
    NOT_ASSIGNED: 1,
    ASSIGNED: 2,
    TEMPORARY_BLOCK: 3,
    PERMANENT_BLOCK: 4,
    REPLACED:5
}
export default CardStatus;